"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INTERNATIONAL_TELEPHONE_ENABLED = void 0;
exports.normalizeTelephone = normalizeTelephone;
exports.parseTelephoneInput = parseTelephoneInput;
exports.isValidTelephone = isValidTelephone;
const country_calling_codes_1 = require("./country-calling-codes");
const nanp_npa_1 = require("./nanp-npa");
/**
 * Set to true when the app is ready to accept non-US telephone numbers.
 * While false, all numbers are normalized and validated as US/CA NANP
 * (+1, 10-digit national, US or Canada NPA only — Caribbean/territory NPAs rejected).
 */
exports.INTERNATIONAL_TELEPHONE_ENABLED = false;
const VALID_COUNTRY_CALLING_CODES = country_calling_codes_1.COUNTRY_CALLING_CODES;
const MIN_NATIONAL_NUMBER_LENGTH = 4;
const MAX_E164_DIGITS = 15;
const US_COUNTRY_CALLING_CODE = '1';
const US_NATIONAL_NUMBER_LENGTH = 10;
function digitsOnly(raw) {
  return raw.replace(/\D/g, '');
}
function findCountryCallingCode(digits) {
  for (const code of VALID_COUNTRY_CALLING_CODES) {
    if (!digits.startsWith(code)) {
      continue;
    }
    const nationalNumber = digits.slice(code.length);
    if (nationalNumber.length < MIN_NATIONAL_NUMBER_LENGTH) {
      continue;
    }
    if (code === US_COUNTRY_CALLING_CODE && nationalNumber.length !== US_NATIONAL_NUMBER_LENGTH) {
      continue;
    }
    return code;
  }
  return null;
}
function normalizeInternationalTelephone(digits) {
  const callingCode = findCountryCallingCode(digits);
  if (callingCode) {
    return "+".concat(digits);
  }
  return "+".concat(US_COUNTRY_CALLING_CODE).concat(digits);
}
function normalizeUsTelephone(digits) {
  if (digits.startsWith(US_COUNTRY_CALLING_CODE) && digits.length === US_NATIONAL_NUMBER_LENGTH + 1) {
    return "+".concat(digits);
  }
  return "+".concat(US_COUNTRY_CALLING_CODE).concat(digits);
}
function normalizeTelephone(raw) {
  const trimmed = raw.trim();
  if (!trimmed) {
    return '';
  }
  const digits = digitsOnly(trimmed);
  if (!digits) {
    return '';
  }
  if (exports.INTERNATIONAL_TELEPHONE_ENABLED) {
    return normalizeInternationalTelephone(digits);
  }
  return normalizeUsTelephone(digits);
}
function parseTelephoneInput(raw) {
  const normalized = normalizeTelephone(raw);
  if (!isValidTelephone(normalized)) {
    return null;
  }
  return normalized;
}
function isValidInternationalTelephone(telephone) {
  const digits = telephone.slice(1);
  if (!/^\d+$/.test(digits) || digits.length < 8 || digits.length > MAX_E164_DIGITS) {
    return false;
  }
  return findCountryCallingCode(digits) !== null;
}
function isValidUsTelephone(telephone) {
  if (!telephone.startsWith("+".concat(US_COUNTRY_CALLING_CODE))) {
    return false;
  }
  const nationalNumber = telephone.slice(2);
  if (!/^\d{10}$/.test(nationalNumber)) {
    return false;
  }
  // Reject Caribbean / territory NANP NPAs (SMS-pumping routes) while still allowing US + Canada.
  return (0, nanp_npa_1.isUsOrCanadaNanpNpa)(nationalNumber.slice(0, 3));
}
function isValidTelephone(telephone) {
  if (typeof telephone !== 'string' || !telephone.startsWith('+')) {
    return false;
  }
  if (exports.INTERNATIONAL_TELEPHONE_ENABLED) {
    return isValidInternationalTelephone(telephone);
  }
  return isValidUsTelephone(telephone);
}
//# sourceMappingURL=normalize-telephone.js.map